import React, { useRef } from "react"
import gsap from "gsap"
import { useGSAP } from "@gsap/react"

import WavesSlider from "./wavesslider"

import {
  AnimationWrapper,
  AnimationBackground,
  AnimatedOverlay,
} from "./quizbanner.styled"

const causes = [
  {
    name: "Stress",
    value: 10,
  },
  {
    name: "Nutrition",
    value: 3,
  },
  {
    name: "Lifestyle",
    value: 9,
  },
  {
    name: "Hormones",
    value: 8,
  },
  {
    name: "Metabolism",
    value: 7,
  },
  {
    name: "Aging",
    value: 6,
  },
]

const QuizBannerAnimation = () => {
  const animatedBackgroundRef = useRef(null)

  useGSAP(() => {
    gsap.to(animatedBackgroundRef.current, {
      filter: "blur(50px)",
      scrollTrigger: {
        trigger: animatedBackgroundRef.current,
        start: "top center",
        end: "center center",
        scrub: 1,
        pinnedContainer: "#growth-pin-wrapper",
        invalidateOnRefresh: true,
        // markers: true,
      },
    })
  })

  return (
    <AnimationWrapper>
      <AnimationBackground
        role={`presentation`}
        ref={animatedBackgroundRef}
        src="https://images.ctfassets.net/0rbfqd9c4jdo/6EAPzpOqjcxPYWy5WqLENn/bc376639e4ebb021382670396d2f3ba3/quiz-banner-bg.jpg?fl=progressive"
        alt=""
      />
      <AnimatedOverlay>
        <WavesSlider causes={causes} />
      </AnimatedOverlay>
    </AnimationWrapper>
  )
}

export default QuizBannerAnimation
